export default __webpack_public_path__ + "static/media/AcornOffice_18.98d49eed.png";